<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-form ref="form" @submit="Confirm" lazy-validation>
          <v-card class="elevation-12">
            <v-card-title primary-title class="primary">
              <div class="headline white--text">Forgot Password</div>
            </v-card-title>
            <v-card-text>
              <v-text-field
                autocomplete="username"
                prepend-icon="person"
                name="username"
                label="Username"
                :rules="nameRules"
                :disabled="loading"
                v-model="user.username"
                type="text">
              </v-text-field>
              <v-text-field
                v-model="user.code"
                :disabled="loading"
                prepend-icon="person"
                name="code"
                label="Code"
                type="text"
              ></v-text-field>
              <v-text-field
                v-model="user.newPassword"
                :disabled="loading"
                prepend-icon="lock"
                name="password"
                label="Password"
                type="password"
              ></v-text-field>
              <router-link :to="{ name: 'SignUp' }">Register</router-link>&nbsp;
              <router-link :to="{ name: 'SignIn' }">Login</router-link>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                @click="Confirm"
                :loading="loading"
                type="submit">
                Confirm
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: 'ForgotPassword',
    data() {
      return {
        loading: false,
        nameRules: [
          (v) => !!v || 'Username ist ein Pflichtfeld',
          (v) => (v && v.length <= 10) || 'Username must be less than 10 characters',
        ],
        codeRules: [
          (v) => !!v || 'Verification Code ist ein Pflichtfeld',
        ],
        user: {
          username: null,
          code: null,
        },
      };
    },
    computed: {
      ...mapGetters({
        username: 'guest/auth/username',
      }),
    },
    methods: {
      ...mapActions({
        forgotPassword: 'guest/auth/forgotPassword',
        showSnackbar: 'common/snackbar/success',
      }),
      Confirm(e) {
        e.preventDefault();
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.forgotPassword(this.user)
            .then((res) => {
              this.loading = false;
              if (res) {
                this.showSnackbar('Check your email for the activation code');
                this.$router.push({name: 'ForgotPasswordSubmit'});
              }
            });
        }
      },
    },
    mounted() {
      if (this.username) {
        this.user.username = this.username;
      }
    },
  };
</script>

<style scoped>

</style>
